import BonusTeam from "components/BonusTeam";
import Modal from "components/Modal";
import Skills from "components/Skills/Skills";
import TrainerType from "components/TrainerType";
import RATINGS from "constants/ratings";
import { FunctionComponent, useMemo } from "react";
import { IRosterSkill } from "types/Skill";
import ITrainer from "types/Trainer";
import ImagesUtils from "utils/images";
import { jsonSkills } from "utils/json";
import RatingUtils from "utils/rating";
import S from "./styled";

type OwnProps = {
  onClose: () => null;
  data: ITrainer;
};
type Props = OwnProps;

const TrainerDetails: FunctionComponent<Props> = ({ data, onClose }) => {
  console.log(data.skills, data.level);

  const skills = useMemo(() => {
    const entries = Object.entries(data.skills[data.level]);

    return entries.map(([skillName, skillLevel]) => {
      const jsonSkill = jsonSkills[skillName];

      const _skill = { ...jsonSkill, level: skillLevel };

      return { ..._skill, rating: RatingUtils.rateSkill(_skill) };
    });
  }, [data.level]);

  const devBonuses = data.devBonus[data.level];

  return (
    <Modal onClose={onClose} style={{ width: "800px", maxWidth: "90vw" }}>
      <S.Container>
        <S.Section>
          <S.Profile>
            <S.ProfileImage>
              <img src={ImagesUtils.getTrainerImage(data.name)} />
            </S.ProfileImage>
            <S.ProfileDetails>
              <div>
                {data.name}

                <S.Level>Lvl. {data.level}</S.Level>
              </div>
              <div>
                <S.Icon>
                  <TrainerType types={data.type} size={40} />
                </S.Icon>

                {data.bonusTeam?.map((team) => (
                  <S.Icon>
                    <img src={ImagesUtils.getTeamImage(team)} />
                  </S.Icon>
                ))}
              </div>
            </S.ProfileDetails>
          </S.Profile>
        </S.Section>

        <S.Section>
          <h3>Skills</h3>
          <Skills skills={skills} />
        </S.Section>

        <S.Section>
          <h3>Dev. Bonuses</h3>
          <S.DevBonuses>
            {devBonuses.map((devBonus) => (
              <div>{devBonus}</div>
            ))}
          </S.DevBonuses>
        </S.Section>
      </S.Container>
    </Modal>
  );
};

export default TrainerDetails;
